import { render, staticRenderFns } from "./PhoneAudioIcons.vue?vue&type=template&id=0b526a53&scoped=true&lang=pug"
import script from "./PhoneAudioIcons.vue?vue&type=script&lang=js"
export * from "./PhoneAudioIcons.vue?vue&type=script&lang=js"
import style0 from "./PhoneAudioIcons.vue?vue&type=style&index=0&id=0b526a53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b526a53",
  null
  
)

export default component.exports